module.exports = __webpack_public_path__ + "static/media/thailand.de386647.svg";